import { nanoid } from 'nanoid'
/* @ngInject */

function GuestsController ($scope,
  $rootScope,
  $q,
  $state,
  $translate,
  $timeout,
  AdminService,
  UdsModalService,
  Utils) {
  const getInviteGuestsDialogController = () =>
    $q.when(import('../../dialogs/invite-guests/invite-guests-dialog.controller'))

  const getEditGuestDialogController = () =>
    $q.when(import('../../dialogs/edit-guest/edit-guest-dialog.controller'))

  const getGuestPermissionsDialogController = () =>
    $q.when(import('../../dialogs/guest-permissions/guest-permissions-dialog.controller'))

  const getImportGuestsDialogController = () =>
    $q.when(import('../../dialogs/import-guests/import-guests-dialog.controller'))

  $scope.bUserNotAuthorized = false
  $scope.selectedMenuId = $state.current.data.selectedMenuId
  $scope.loading = true
  $scope.lastRequestId = null
  $scope.guestFilters = {
    status: ['ACTIVE', 'INACTIVE'],
    selectedStatusCache: null,
    search: ''
  }
  $scope.sort = {
    $sort: 'createdAt',
    $order: 'DESC'
  }

  $scope.hasLicenseFeatureEnabled = true
  $scope.activeUsers = null
  $scope.pageTitle = $translate.instant('manageGuests.guests')
  $scope.guests = null

  const api = {
    getInviteGuestsDialogController,
    getEditGuestDialogController,
    getGuestPermissionsDialogController,
    _openImportGuestsDialog,
    _openInviteGuestsDialog,
    _skipPagingTo,
    _handleGetGuestsResponse,
    _editGuestClick,
    _openPermissionsModal,
    _updateFilters,
    _updateSort,
    _onSearchGuests: Utils.debounce(_onSearchGuests),
    _setHeader
  }

  this.getApi = () => api

  function activate () {
    api._skipPagingTo(null, 0)

    $rootScope.getUser().then(user => {
      $scope.bUserNotAuthorized = !$rootScope.isUserSysAdminAdmin(user)
      api._setHeader()
    })
  }

  $scope.skipPagingTo = api._skipPagingTo

  $scope.tableInfo = {
    emptyMode: {
      tooltip: '',
      title: $translate.instant('manageGuests.noGuestsFound'),
      button: {
        text: $translate.instant('manageGuests.addGuest'),
        icon: 'user-plus',
        buttonClick: api._openInviteGuestsDialog
      }
    },
    columns: [
      { name: $translate.instant('manageGuests.table.user'), orderable: true, value: 'name' },
      { name: $translate.instant('manageGuests.table.email'), orderable: false, value: 'email' },
      { name: $translate.instant('manageGuests.table.status'), orderable: false, value: 'status' }
    ],
    columnsGrid: '25% 35% 25% 5%',
    rows: [],
    editButton: {
      openUpdateGuestModal: api._editGuestClick,
      openPermissionsModal: api._openPermissionsModal,
      inactivateGuest: true,
      deleteGuest: true,
      dropdown: true
    },
    updateFilters: api._updateFilters,
    updateSort: api._updateSort,
    refresherCounter: 0,
    paging: {
      top: 16,
      count: 0,
      index: 0,
      onTokenSelect: api._skipPagingTo
    }
  }

  activate()

  $scope.$watchCollection('headerToolbar.filter.params', () => {
    $scope.guestFilters = $scope.headerToolbar.filter.params

    if (!$scope.guestFilters.status) {
      $scope.tableInfo.rows = []
      $scope.tableInfo.paging.count = 0
    } else {
      api._skipPagingTo(null, 0)
    }
  })

  function _handleGetGuestsResponse (res) {
    $scope.tableInfo.paging.count = res.count
    $scope.tableInfo.rows = res.rows.map(guest => {
      const status = guest.active === true ? 'ACTIVE' : 'INACTIVE'

      return {
        id: guest.userId,
        guestStatus: status,
        email: guest.email,
        name: guest.name,
        values: [
          { type: 'USER', value: guest },
          { type: 'TEXT', value: guest.email },
          { type: 'ACTIVE', value: status }
        ]
      }
    })

    $scope.loading = false
    $scope.tableInfo.refresherCounter++

    $timeout(() => {
      $scope.$broadcast('core-table.updateGrid')
    }, 50, true)
  }

  function _skipPagingTo (event, token) {
    const requestId = nanoid()
    $scope.lastRequestId = requestId
    token = event ? event.detail.currentPage - 1 : token
    $scope.loading = true
    $scope.currentPage = token
    $scope.tableInfo.paging.index = token

    AdminService.filterGuests(
      $scope.tableInfo.paging.top,
      $scope.tableInfo.paging.top * token,
      $scope.guestFilters,
      $scope.sort
    )
      .then((guests) => {
        const isLastRequest = requestId === $scope.lastRequestId
        if (isLastRequest) {
          api._handleGetGuestsResponse(guests)
        }
      })
      .catch((err) => {
        console.error(err)
        $scope.loading = false
      })
  }

  function _updateFilters (filter, value) {
    if (filter === 'filters') {
      $scope.guestFilters.selectedStatusCache =
      value.status && value.status.length ? value.status : ['ACTIVE', 'INACTIVE']
      $scope.guestFilters.status = value.status && value.status.length ? value.status : ['ACTIVE', 'INACTIVE']
    } else if (filter === 'search') {
      $scope.guestFilters.search = value
    }

    if (!$scope.guestFilters.status) {
      $scope.tableInfo.rows = []
      $scope.tableInfo.paging.count = 0
    } else {
      api._skipPagingTo(null, 0)
    }
  }

  function _setHeader () {
    if ($rootScope.isDesktop) {
      $scope.headerToolbar = {
        rightButtons: [
          {
            type: 'button',
            btnType: 'primary',
            icon: 'user-plus',
            label: $translate.instant('manageGuests.addGuest'),
            onClick: api._openInviteGuestsDialog
          }
        ],
        search: {
          onSearch: api._onSearchGuests
        },
        filter: {
          params: {
            status: [

            ]
          },
          items: [
            { id: 3, name: 'GUEST_STATUS', order: 1 }
          ]
        }
      }

      if ($rootScope.isUserSysAdmin()) {
        $scope.headerToolbar.rightButtons.unshift({
          type: 'button',
          btnType: 'secondary',
          icon: 'plus',
          label: $translate.instant('manageGuests.importGuests'),
          onClick: api._openImportGuestsDialog
        })
      }
    }
  }

  function _updateSort (newSort) {
    $scope.sort = newSort

    api._skipPagingTo(null, $scope.currentPage)
  }

  function _onSearchGuests (term) {
    api._updateFilters('search', term)
  }

  function _editGuestClick (row) {
    getEditGuestDialogController().then(({ EditGuestDialogController }) => {
      const editGuestDialog = UdsModalService.createModal({
        controller: EditGuestDialogController,
        modalName: 'editGuestDialog',
        data: {
          id: row.id,
          name: row.name,
          email: row.email
        }
      })
      editGuestDialog.open()
    })
  }

  function _openPermissionsModal (guestId) {
    getGuestPermissionsDialogController().then(({ GuestPermissionsDialogController }) => {
      const guestPermissionsDialog = UdsModalService.createModal({
        controller: GuestPermissionsDialogController,
        modalName: 'guestPermissionsDialog',
        data: {
          guestId
        }
      })

      guestPermissionsDialog.open()
    })
  }

  function _openImportGuestsDialog () {
    getImportGuestsDialogController().then(({ ImportGuestsDialogController }) => {
      const importGuestsDialog = UdsModalService.createModal({
        controller: ImportGuestsDialogController,
        modalName: 'importGuestsDialog'
      })

      importGuestsDialog.open()
    })
  }

  function _openInviteGuestsDialog () {
    getInviteGuestsDialogController().then(({ InviteGuestsDialogController }) => {
      const inviteGuestsDialog = UdsModalService.createModal({
        controller: InviteGuestsDialogController,
        modalName: 'inviteGuestsDialog',
        onClose: (dialogResponse) => {
          if (dialogResponse) {
            $scope.inviteGuestsConfirm(dialogResponse.isSuccess)
          }
        }
      })

      inviteGuestsDialog.open()
    })
  }

  $scope.inviteGuestsConfirm = function (isSuccess) {
    if (isSuccess) {
      $scope.$broadcast('filters.updateUserFilters')
      api._skipPagingTo(null, 0)
    }
  }

  const deregisterAllGuestsReload = $scope.$on('guests.reloadAllGuests', samePage => {
    if (samePage) {
      api._skipPagingTo(null, $scope.currentPage)
      return
    }
    api._skipPagingTo(null, 0)
  })

  $scope.$on('$destroy', () => {
    deregisterAllGuestsReload()
  })
}

export { GuestsController }
